import React from 'react';

import { useApp } from '../../../store/AppContext';
import HeaderDayCell from './HeaderDayCell';
import MonthHeaderCell from './MonthHeaderCell';
import WeekHeaderCell from './WeekHeaderCell';

export default function HeaderGrid({ monthGroups, weekGroups }) {
  const { days } = useApp();
  return (
    <>
      {/* ── Ligne mois ── */}
      {monthGroups.map((mg) => (
        <MonthHeaderCell key={mg.key} mg={mg} />
      ))}
      {/* ── Ligne numéro de semaine ── */}
      {weekGroups.map((wg) => (
        <WeekHeaderCell key={wg.key} wg={wg} />
      ))}
      {/* ── Ligne jours ── */}
      {days.map((day) => (
        <HeaderDayCell key={day.iso} day={day} />
      ))}
    </>
  );
}
